// types.ts - New file to hold shared types and enums
export enum MenuVariant {
  DEFAULT = 'default',
  SIDE_NAV = 'sideNav',
  MODAL_SIDE_NAV = 'modal_side_nav',
}

export enum MenuTheme {
  GRAY = 'gray',
}
